// extracted by mini-css-extract-plugin
export default {"page":"CouponsUsage_page__RAUNs","wrapper":"CouponsUsage_wrapper__V-okS","couponsTable":"CouponsUsage_couponsTable__5N79s"};